import { render, staticRenderFns } from "./serviceOrderRatings.vue?vue&type=template&id=70d24c71&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./serviceOrderRatings.vue?vue&type=style&index=0&id=70d24c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d24c71",
  null
  
)

export default component.exports